<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="heading-1 mb-4">
                            <span>RAHT</span>
                        </h4>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <b-row
                            v-for="(item, index) in itens"
                            :key="item.rahtItemTemplateId"
                        >
                            <b-col sm="12">
                                <b-form-group>
                                    <label class="required">{{
                                        item.titulo
                                    }}</label>
                                    <b-form-textarea
                                        v-model="itens[index].conteudo"
                                        :rows="4"
                                        :disabled="desabilitarFormulario"
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer v-if="mostrarBtnSalvar">
                        <b-button
                            variant="primary"
                            @click.stop="confirmaAtualizarRaht()"
                            v-if="mostrarBtnSalvar"
                        >
                            <span> <i class="fa fa-floppy-o"></i> Salvar </span>
                        </b-button>
                        <div class="float-right">
                            <label class="required ml-3 pt-2"></label>
                            <label class="ml-2 pt-2">Campos Obrigatórios</label>
                        </div>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    components: {},

    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            raht: {},
            itens: []
        }
    },

    methods: {
        verificarPreenchimentoRaht() {
            let camposVazios = []
            for (let index = 0; index < this.itens.length; index++) {
                const element = this.itens[index]
                if (!element.conteudo || element.conteudo.trim() == '') {
                    camposVazios.push(element.titulo)
                }
            }
            return camposVazios
        },

        preencherFormulario() {
            this.raht.rahtId = this.consultoria.raht.rahtId
            this.raht.consultoriaId = this.consultoria.consultoriaId
            this.itens = [...this.consultoria.raht.itens]
        },

        confirmaAtualizarRaht() {
            let camposVazios = this.verificarPreenchimentoRaht()
            if (camposVazios.length > 0) {
                this.$swal({
                    title: 'Atualização da RAHT',
                    html: `O${camposVazios.length > 1 ? 's' : ''} campo${
                        camposVazios.length > 1 ? 's' : ''
                    } <strong>${camposVazios.join(' / ')}</strong> não ${
                        camposVazios.length > 1 ? 'foram' : 'foi'
                    } preenchido${camposVazios.length > 1 ? 's' : ''}!!!`,
                    icon: 'error'
                })
            } else {
                this.$swal({
                    title: 'Atualização da RAHT',
                    html: `Confirma a atualização da RAHT?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.atualizarRaht()
                    }
                })
            }
        },

        atualizarRaht() {
            this.$store.dispatch('addRequest')
            this.raht.itens = [...this.itens]
            this.servicos.atualizarConsultoriaRaht(this.raht).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterConsultoriaAtualizada')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    validations: {
        preenchimentoRaht: {
            camposOk() {
                return this.itens.every(
                    item => item.conteudo != null && item.conteudo.trim() != ''
                )
            }
        }
    },

    watch: {
        consultoria() {
            this.preencherFormulario()
        }
    },

    computed: {
        desabilitarFormulario() {
            return (
                !this.$temAcesso('APPSE-FORN-CONS-02') ||
                (this.consultoria.status !== consultoriaStatus.EM_ANDAMENTO &&
                    this.consultoria.status !==
                        consultoriaStatus.CONCLUIDA_PENDENTE_ANALISE &&
                    this.consultoria.status !==
                        consultoriaStatus.CONCLUIDA_PENDENTE_CORRECAO)
            )
        },

        mostrarBtnSalvar() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-02') &&
                (this.consultoria.status === consultoriaStatus.EM_ANDAMENTO ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_ANALISE ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_CORRECAO)
            )
        }
    }
}
</script>
